import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
// Assets
import Image1 from '../../../../assets/images/education/image1.jpeg';
import Image2 from '../../../../assets/images/home/education-down.png';
import BackImage from '../../../../assets/images/education/back-image.png';

const EducationSection = () => {
  return (
    <section className="education">
      <Container fluid="lg">
        <Row className="education__up">
          <h1 className="title-md-section">
            Educación que transforma la experiencia de la menopausia
          </h1>
          <Col className="image-box">
            <img
              src={BackImage}
              alt="Imagen la menopausia es evolución"
              className="image back"
            />
            <img
              src={Image1}
              alt="Imagen la menopausia es evolución"
              className="image front"
            />
          </Col>
        </Row>
        <Row className="education__down">
          <Col className="image-box">
            <img
              src={BackImage}
              alt="Imagen la menopausia es evolución"
              className="image back-alt"
            />
            <img
              src={Image2}
              alt="Imagen la menopausia es evolución"
              className="image"
            />
          </Col>
          <Col className="content-text">
            <p className="paragraph">
              La mayoría de las personas carece de conocimientos precisos sobre la perimenopausia y la menopausia.
            </p>
            <p className="paragraph mt-1">
              Mi propuesta educativa busca transformar las narrativas estigmatizantes, ofreciendo conocimiento  
              <span className="paragraph paragraph-alt">
                &nbsp;desde una perspectiva feminista e interseccional,&nbsp;
              </span>
              con enfoque participativo y comunitario.
            </p>
            <Nav.Link href="/educacion" className="main-btn mt-2">
              Quiero ver
            </Nav.Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EducationSection;
